export function fetchCommonValue<T, R>(
  source: T[],
  fetcher: (x: T) => R
): R | undefined {
  if (source.length === 0) {
    return undefined;
  }
  if (source.length === 1) {
    return fetcher(source[0]);
  }
  if (fetcher(source[0]) !== fetcher(source[1])) {
    return undefined;
  } else {
    return fetchCommonValue(source.slice(1, source.length), fetcher);
  }
}
